<div class="mobility-phone-input">
  <label class="mobility-phone-input__label">
    {{ 'user-agreement-sign-page.mobility-budget.phone-step.phone-number-label' | translate }}
  </label>

  <div
    class="mobility-phone-input__input-row"
    [class.mobility-phone-input__input-row_confirmed]="isConfirmed()"
    [class.mobility-phone-input__input-row_error]="showError()"
  >
    @if (isConfirmed()) {
      <span class="mobility-phone-input__country-readonly">
        <img alt="" class="mobility-phone-input__flag" [src]="getFlagUrl(selectedCountry())" />
        <span class="mobility-phone-input__calling-code">{{ selectedCallingCode() }}</span>
      </span>
    } @else {
      <button
        class="mobility-phone-input__country-trigger"
        type="button"
        [matMenuTriggerFor]="countryMenu"
      >
        <img alt="" class="mobility-phone-input__flag" [src]="getFlagUrl(selectedCountry())" />
        <span class="mobility-phone-input__calling-code">{{ selectedCallingCode() }}</span>
        <mat-icon class="mobility-phone-input__arrow">arrow_drop_down</mat-icon>
      </button>
    }

    <input
      #phoneInput
      autocomplete="tel-national"
      class="mobility-phone-input__phone-input"
      inputmode="tel"
      type="tel"
      [readOnly]="isConfirmed()"
      (input)="onPhoneInput($event)"
      (paste)="onPhonePaste($event)"
    />

    @if (hasPhoneValue() && !isConfirmed()) {
      <mat-icon
        class="mobility-phone-input__clear-button-icon"
        [attr.aria-label]="'general.remove-img' | translate"
        [style.color]="wls.accentColor"
        [svgIcon]="'fo-close-circle'"
        (click)="clearPhone()"
      ></mat-icon>
    }
  </div>
</div>

<mat-menu
  #countryMenu="matMenu"
  class="mobility-phone-input__country-menu"
  [overlapTrigger]="false"
>
  <div class="mobility-phone-input__menu-label">
    {{ 'user-agreement-sign-page.mobility-budget.phone-step.favorite-countries' | translate }}
  </div>
  @for (country of countryOptions().favoriteCountries; track country.code) {
    <button
      class="mobility-phone-input__menu-item"
      mat-menu-item
      type="button"
      [class.mobility-phone-input__menu-item_selected]="country.code === selectedCountry()"
      (click)="onCountryChange(country.code)"
    >
      <span class="mobility-phone-input__option">
        <img alt="" class="mobility-phone-input__flag" [src]="getFlagUrl(country.code)" />
        <span class="mobility-phone-input__country-name">{{ country.name }}</span>
        <span class="mobility-phone-input__country-code">{{ country.callingCode }}</span>
      </span>
    </button>
  }

  <div class="mobility-phone-input__menu-divider"></div>

  <div class="mobility-phone-input__menu-label">
    {{ 'user-agreement-sign-page.mobility-budget.phone-step.all-countries' | translate }}
  </div>
  @for (country of countryOptions().otherCountries; track country.code) {
    <button
      class="mobility-phone-input__menu-item"
      mat-menu-item
      type="button"
      [class.mobility-phone-input__menu-item_selected]="country.code === selectedCountry()"
      (click)="onCountryChange(country.code)"
    >
      <span class="mobility-phone-input__option">
        <img alt="" class="mobility-phone-input__flag" [src]="getFlagUrl(country.code)" />
        <span class="mobility-phone-input__country-name">{{ country.name }}</span>
        <span class="mobility-phone-input__country-code">{{ country.callingCode }}</span>
      </span>
    </button>
  }
</mat-menu>
